import {
    Box,
    Grid,
    TextField,
    Typography,
} from '@mui/material';

import { IComunidadesRuraisTradicionais } from 'stores/forms/comunidades_rurais_tradicionais';
import { formatDateToBR } from 'utils/dateUtils';

interface ViewInformanteProps {
    formData: IComunidadesRuraisTradicionais;
}

export const ViewInformante: React.FC<ViewInformanteProps> = ({
    formData,
}) => {
    return (
        <Box sx={{ mt: 2 }}>
            <Typography
                variant='h5'
                gutterBottom
                sx={{ fontWeight: 'bold', mb: 4 }}
            >
                Informações do Formulário
            </Typography>

            <Grid container spacing={3} sx={{ mb: 3 }}>
                <Grid item xs={6}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
                        UUID do Formulário
                    </Typography>
                    <TextField
                        fullWidth
                        value={formData.uuid || ''}
                        InputProps={{
                            readOnly: true,
                            sx: { backgroundColor: '#f5f5f5' },
                        }}
                    />
                </Grid>

                <Grid item xs={6}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
                        Status do Pacote
                    </Typography>
                    <TextField
                        fullWidth
                        value={formData.pacote_status || ''}
                        InputProps={{
                            readOnly: true,
                            sx: { backgroundColor: '#f5f5f5' },
                        }}
                    />
                </Grid>
            </Grid>

            <Grid container spacing={3} sx={{ mb: 3 }}>
                <Grid item xs={6}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
                        Data de Criação
                    </Typography>
                    <TextField
                        fullWidth
                        value={formatDateToBR(formData.createdAt)}
                        InputProps={{
                            readOnly: true,
                            sx: { backgroundColor: '#f5f5f5' },
                        }}
                    />
                </Grid>

                <Grid item xs={6}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
                        Última Atualização
                    </Typography>
                    <TextField
                        fullWidth
                        value={formatDateToBR(formData.updatedAt)}
                        InputProps={{
                            readOnly: true,
                            sx: { backgroundColor: '#f5f5f5' },
                        }}
                    />
                </Grid>
            </Grid>

            <Grid container spacing={3} sx={{ mb: 3 }}>
                <Grid item xs={6}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
                        Criado por
                    </Typography>
                    <TextField
                        fullWidth
                        value={formData.created_by || ''}
                        InputProps={{
                            readOnly: true,
                            sx: { backgroundColor: '#f5f5f5' },
                        }}
                    />
                </Grid>

                <Grid item xs={6}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
                        Atualizado por
                    </Typography>
                    <TextField
                        fullWidth
                        value={formData.updated_by || ''}
                        InputProps={{
                            readOnly: true,
                            sx: { backgroundColor: '#f5f5f5' },
                        }}
                    />
                </Grid>
            </Grid>

            <Grid container spacing={3} sx={{ mb: 3 }}>
                <Grid item xs={12}>
                    <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
                        UUID da Instituição
                    </Typography>
                    <TextField
                        fullWidth
                        value={formData.institution_uuid || ''}
                        InputProps={{
                            readOnly: true,
                            sx: { backgroundColor: '#f5f5f5' },
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}; 